module.exports = __webpack_public_path__ + "media/components/country-flag/static/md-3ed4170d7a178901e6566eaf456574cc.svg";